<template>
  <v-app id="mainWrap">
    <topbar v-if="login" :swipDisplay="displayBackBtn" />
    <MobileBottomNav v-if="login" />
    <sidemenu v-if="login" />
    <v-main id="scroll-target" v-scroll.self="onScroll">
      <span id="floatAlert">
        <span v-if="advertisementNotifications.length">
          <AdvertisementBanner
            v-for="(advertisement, index) in advertisementNotifications"
            :key="index + '-1'"
            :activator="
              advertisementNotifications.length > 0 &&
              advertisement.dispatch.advertisement &&
              advertisement.dispatch.watched_at == null
            "
            :ad="advertisement"
            type="advertisement"
          />
        </span>
        <span v-if="systemNotifications.length">
          <AdvertisementModal
            v-for="(notification, index) in systemNotifications"
            :key="index + '-2'"
            :activator="
              notification.dispatch.advertisement.type != 'banner' &&
              notification.dispatch.watched_at == null &&
              systemNotifications.length > 0
            "
            :ad="notification"
            type="system"
          />
          <AdvertisementBanner
            v-for="(notification, index) in systemNotifications"
            :key="index + '-3'"
            :activator="
              notification.dispatch.advertisement.type == 'banner' &&
              notification.dispatch.watched_at == null &&
              systemNotifications.length > 0
            "
            :ad="notification"
            type="system"
          />
        </span>
        <span v-if="promotionNotifications.length">
          <AdvertisementModal
            v-for="(notification, index) in promotionNotifications"
            :key="index + '-4'"
            :activator="
              promotionNotifications.length > 0 &&
              notification.dispatch.watched_at == null
            "
            :ad="notification"
            type="promotion"
          />
        </span>
      </span>
      <NotsCount />
      <router-view v-if="showPages" />
      <loading v-else />
    </v-main>
    <Toaster />
    <NotificationAlerts />
    <ChangePassModal :activator="changePass" @close="closeModal" />
    <EmailConfirmationDialog :dialog="verifyEmail" @close="closeEmailModal" />
    <NotificationsToConfirm />
    <!-- <ChangePassModal :activator="changePass" @close="closeModal" /> -->
    <PushNotificationsDialog v-if="login && !isKioskSession" />
    <v-dialog v-model="authRetryDialog" persistent max-width="420">
      <v-card>
        <v-card-title>{{ $t("auth-retry-title") }}</v-card-title>
        <v-card-text>
          {{ $t("auth-retry-message") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" @click="forceLogin">
            {{ $t("auth-retry-login-again") }}
          </v-btn>
          <v-btn
            color="switchq"
            dark
            :loading="authRetryLoading"
            @click="retryAuthRestore"
          >
            {{ $t("retry") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import ChangePassModal from "@/components/general/ChangePassModal.vue";
import EmailConfirmationDialog from "@/views/forms/emailConfirmationDialog.vue";
import NotsCount from "@/components/general/NotsCount.vue";
import NotificationsToConfirm from "@/components/general/NotificationsToConfirm.vue";
import Sidemenu from "@/components/app_parts/sidemenu.vue";
import Topbar from "@/components/app_parts/topbar.vue";
import MobileBottomNav from "@/components/app_parts/MobileBottomNav.vue";
import lang from "./helpers/lang";
import socketMixin from "@/mixins/socketMixin";
import clientDeviceMixin from "@/mixins/clientDeviceMixin";
import auth from "@/helpers/auth";
import Toaster from "@/components/app_parts/Toaster.vue";
import NotificationAlerts from "@/components/app_parts/NotificationAlerts.vue";
import PushNotificationsDialog from "@/components/tools/PushNotificationsDialog.vue";
import loading from "./components/tools/loading.vue";
import AdvertisementBanner from "@/components/general/AdvertisementBanner.vue";
import AdvertisementModal from "@/components/general/AdvertisementModal.vue";
import axios from "@/plugins/axios";
import logger from "@/plugins/appsLogsCore";
export default {
  name: "App",
  components: {
    Topbar,
    MobileBottomNav,
    Sidemenu,
    Toaster,
    NotificationAlerts,
    PushNotificationsDialog,
    loading,
    ChangePassModal,
    NotificationsToConfirm,
    AdvertisementBanner,
    AdvertisementModal,
    NotsCount,
    EmailConfirmationDialog,
  },
  mixins: [socketMixin, clientDeviceMixin],
  data() {
    return {
      initiated: false,
      notsDialog: false,

      intervals: {},
      pulled: 0,
      scrollInterval: null,
      advertisements: null,
      scrollY: 0,
      lastScrollTop: 0,
      loadingIcon: "mdi-reload",
      displayBackBtn: true,
      changePass: false,
      verifyEmail: false,
      authRetryDialog: false,
      authRetryLoading: false,
      appMetaLoading: false,
      appMetaLoaded: false,
      scroll: 0,
      topConfig: {
        pullText: this.$t("pullTo"),
        triggerText: this.$t("releaseTo"),
        loadingText: this.$t("refresh"),
        failText: this.$t("refreshFail"),
        triggerDistance: 95,
      },
    };
  },
  computed: {
    showPages() {
      const token = this.token;
      const checked = this.checked;
      const loadingDevices = this.loadingDevices;
      return (token && checked && !loadingDevices) || !token;
    },
    login() {
      return this.$store.getters["user/valid"];
    },
    isKioskSession() {
      return auth.isReadOnly();
    },
    token() {
      return this.$store.getters["user/token"];
    },
    checked() {
      return this.$store.getters["user/checked"];
    },
    loadingDevices() {
      return this.$store.getters["devices/loading"];
    },
    advertisementNotifications() {
      return JSON.parse(
        JSON.stringify(
          this.$store.getters["notificationAdvertisements/notifications"]
        )
      );
    },
    systemNotifications() {
      return JSON.parse(
        JSON.stringify(
          this.$store.getters["systemAdvertisements/notifications"]
        )
      );
    },
    promotionNotifications() {
      return JSON.parse(
        JSON.stringify(
          this.$store.getters["promotionAdvertisements/notifications"]
        )
      );
    },
    isDark() {
      return this.$store.getters["preferences/isDark"];
    },
  },
  watch: {
    isDark(val) {
      // Keep Vuetify in sync when the theme changes at runtime (e.g. Settings)
      this.$vuetify.theme.dark = val;
    },
    login(v) {
      if (v) {
        this.setHasTopBarClass();
        this.initiate();
        this.inGroup();
      } else {
        this.resetAppSession();
        this.removeHasTopBarClass();
      }
    },
    scrollY() {
      if (this.scrollY < 40) {
        this.displayBackBtn = true;
      }
      this.onScroll();
    },
    $route(to) {
      if (to && to.path === "/login") {
        this.isCustomApp();
      }
      if (this.inGroup()) {
        localStorage.setItem("inGroup", true);
      } else {
        localStorage.setItem("inGroup", false);
      }
    },
  },
  async created() {
    this.fixLocale();
    if (this.token) {
      logger.auth("auth.restore_started");
      const authResult = await this.$store.dispatch("user/get");
      if (authResult && authResult.authFailed && !this.login) {
        logger.auth("auth.restore_failed", {
          reason: "auth_failed",
        });
        this.logOut();
      } else if (authResult && authResult.temporaryFailure && !this.login) {
        logger.auth("auth.restore_temporary_failure", {
          reason: "temporary_failure",
        });
        this.authRetryDialog = true;
        this.$store.dispatch("general/setAlert", {
          type: "failed",
          msg: "connectionProblemRetry",
        });
      } else {
        logger.auth("auth.restore_succeeded");
        this.initiate();
      }
    } else {
      localStorage.removeItem("inGroup");
      localStorage.removeItem("mydata");
      localStorage.removeItem("mydataview");
    }
    this.isCustomApp();
  },
  mounted() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.scrollInterval = setInterval(() => {
        this.scrollY = window.scrollY;
      }, 100);
    }
    // Theme is already applied by main.js (preferences/hydrate).
    // Watch the store so runtime changes propagate immediately.
    this.fixLocale();
    if (this.login) {
      this.setHasTopBarClass();
    } else {
      this.removeHasTopBarClass();
    }
    // console.log(this.advertisementNotifications);
  },
  destroyed() {
    for (const interval in this.intervals) {
      clearInterval(this.intervals[interval]);
    }
    this.intervals = {};
    clearInterval(this.scrollInterval);
  },
  methods: {
    closeModal() {
      this.changePass = false;
    },
    closeEmailModal() {
      this.verifyEmail = false;
    },
    async retryAuthRestore() {
      logger.auth("auth.retry_restore_started");
      this.authRetryLoading = true;
      const authResult = await this.$store.dispatch("user/get");
      this.authRetryLoading = false;

      if (authResult && authResult.ok) {
        logger.auth("auth.retry_restore_succeeded");
        this.authRetryDialog = false;
        this.initiate();
      } else if (authResult && authResult.authFailed) {
        logger.auth("auth.retry_restore_failed", {
          reason: "auth_failed",
        });
        this.authRetryDialog = false;
        this.logOut();
      }
    },
    forceLogin() {
      logger.auth("auth.force_login_requested");
      this.authRetryDialog = false;
      this.logOut();
    },
    resetAppSession() {
      this.initiated = false;
      this.authRetryDialog = false;
      this.authRetryLoading = false;
      this.changePass = false;
      this.verifyEmail = false;

      for (const interval in this.intervals) {
        clearInterval(this.intervals[interval]);
      }
      this.intervals = {};
      this.$store.dispatch("dashboard/clearAutoRefresh");
    },
    inGroup() {
      let inGroup = !!this.$route.params.gslug;
      if (inGroup) {
        localStorage.setItem("inGroup", true);
      }
      localStorage.setItem("inGroup", false);
      return inGroup;
    },
    onScroll() {
      if (this.$vuetify.breakpoint.smAndDown) {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > this.lastScrollTop) {
          this.displayBackBtn = false;
          this.lastScrollTop = st <= 0 ? 0 : st;
        } else if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight
        ) {
          this.displayBackBtn = false;
          this.lastScrollTop = st <= 0 ? 0 : st;
        } else {
          this.displayBackBtn = true;
          this.lastScrollTop = st <= 0 ? 0 : st;
        }
        if (
          window.innerHeight + window.scrollY <= document.body.offsetHeight ==
            false &&
          window.scrollY < 30
        ) {
          this.displayBackBtn = true;
          this.lastScrollTop = st <= 0 ? 0 : st;
        }
      }
    },
    isCustomApp({ force = false } = {}) {
      if (this.appMetaLoading) return;
      if (this.appMetaLoaded && !force) return;

      // Apply cached app metadata immediately so the login page does not
      // have to wait for the network response.
      const cached = localStorage.getItem("app_meta");
      if (cached) {
        try {
          const meta = JSON.parse(cached);
          if (meta.title) document.title = meta.title;
          this.$store.dispatch("general/setCustomApp", !!meta.custom);
        } catch (_) {
          // ignore malformed cache
        }
      }

      // Fetch fresh data and update only when the response differs.
      this.appMetaLoading = true;
      axios
        .get("/app")
        .then((res) => {
          const data = res.data && res.data.data ? res.data.data : null;
          if (!data) return;

          const meta = { title: data.title, custom: !!data.custom };

          // Persist for next load.
          localStorage.setItem("app_meta", JSON.stringify(meta));

          if (meta.title) document.title = meta.title;
          if (meta.custom) {
            localStorage.setItem("customApp", true);
          } else {
            localStorage.removeItem("customApp");
          }
          this.$store.dispatch("general/setCustomApp", meta.custom);
        })
        .catch((err) => {
          console.log("error", err);
        })
        .finally(() => {
          this.appMetaLoading = false;
          this.appMetaLoaded = true;
        });
    },
    stateChange(state) {
      if (state === "pull") {
        this.loadingIcon = "mdi-reload mdi-24px";
      } else {
        this.loadingIcon = "mdi-reload mdi-spin mdi-24px";
      }
    },
    async initiate() {
      if (!this.initiated) {
        // Fetch user preferences from backend and merge with local copy
        this.$store.dispatch("preferences/fetchRemote");
        this.$store.dispatch("dashboard/restoreFromCache");
        this.$store.dispatch("dashboard/restoreAiFromCache");
        this.$store.dispatch("dashboard/fetchInsights", {
          background: true,
          force: true,
        });
        this.$store.dispatch("dashboard/fetchInsightsAi", {
          background: true,
          force: true,
        });
        this.$store.dispatch("devices/fetchDevices");
        this.$store.dispatch("groups/getGroups");
        this.$store.dispatch("business/get");
        this.$store.dispatch("gateways/getGateways");
        this.$store.dispatch("devices/getGatewaysNames");
        this.$store.dispatch("automations/getAutomations");
        this.$store.dispatch("notificationAdvertisements/getNotifications");
        this.$store.dispatch("systemAdvertisements/getNotifications");
        this.$store.dispatch("promotionAdvertisements/getNotifications");
        let user = this.$store.getters["user/user"];
        let notifications = this.$store.getters["user/notifications"];
        this.checkNotificationConfirmations();
        let changePass = user.new_password_required;
        let first_login = localStorage.getItem("first_login");
        if ((first_login && first_login == "12345678") || changePass) {
          this.changePass = 1;
        }
        if (
          (!user.email_confirmed || user.email_confirmed == false) &&
          notifications.email
        ) {
          this.verifyEmail = true;
        }

        // else if (changePass) {
        // localStorage.removeItem("first_login");
        // }
        this.setIntervals();
        await sleep(2000);
        this.generalIntervals();
        this.$store.dispatch("dashboard/ensureAutoRefresh");
        this.initiated = true;
      }
    },
    async generalIntervals() {
      clearInterval(this.intervals.general);
      this.intervals.general = setInterval(async () => {
        this.$store.dispatch("dashboard/fetchInsights", {
          background: true,
          force: true,
        });
        this.$store.dispatch("dashboard/fetchInsightsAi", {
          background: true,
          force: true,
        });
        this.$store.dispatch("devices/fetchDevices");
        this.$store.dispatch("groups/getGroups");
        this.$store.dispatch("business/get");
        this.$store.dispatch("devices/getGatewaysNames");
        this.$store.dispatch("automations/getAutomations");
        this.$store.dispatch("notificationAdvertisements/getNotifications");
        this.$store.dispatch("systemAdvertisements/getNotifications");
        this.$store.dispatch("promotionAdvertisements/getNotifications");
      }, 1000 * 60 * 5);
    },
    async setIntervals() {
      clearInterval(this.intervals.reanalyzeDevices);
      this.intervals.reanalyzeDevices = setInterval(() => {
        this.$store.dispatch("devices/reanalyzeDevices");
      }, 10000);
      clearInterval(this.intervals.advertisements);
      this.intervals.advertisements = setInterval(() => {
        // console.log("run");
        this.$store.dispatch("notificationAdvertisements/getNotifications");
        this.$store.dispatch("systemAdvertisements/getNotifications");
        this.$store.dispatch("promotionAdvertisements/getNotifications");
      }, 1000 * 60 * 30);
    },
    fixLocale() {
      this.$i18n.locale = lang.get();
    },
    setHasTopBarClass() {
      if (document.body) {
        document.body.classList.add("has-topbar");
      }
    },
    removeHasTopBarClass() {
      if (document.body) {
        document.body.classList.remove("has-topbar");
      }
    },
    logOut() {
      logger.auth("auth.app_logout_called");
      this.$store.dispatch("dashboard/reset");
      localStorage.removeItem("mydata");
      localStorage.removeItem("mydataview");
      localStorage.removeItem("customApp");
      auth.logout("app_logout_called");
      logger.resetUser();
      logger.flush();
      this.$router.push("/login");
      logger.auth("session.redirect_to_login", { reason: "app_logout_called" });
    },
    async checkNotificationConfirmations() {
      await this.$store.dispatch("notifications/fetchNotificationsToConfirm");
    },
  },
};
function sleep(ms) {
  // const selection = window.getSelection();

  // console.log("dasdasdasd", selection.rangeCount > 0 && !selection.isCollapsed);
  return new Promise((resolve) => setTimeout(resolve, ms));
}
</script>
